import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const StatsSection = () => {
  const sectionRef = useRef(null);
  const hasAnimatedRef = useRef(false);
  const countersRef = useRef([]);

  const stats = [
    { number: 7000, label: "Designs Digitized", suffix: "+", isDecimal: false },
    { number: 600, label: "Happy Clients Worldwide", suffix: "+", isDecimal: false },
    { number: 13, label: "Years Industry Experience", suffix: "+", isDecimal: false }
  ];

  useEffect(() => {
    const animateCounters = () => {
      countersRef.current.forEach((counter, index) => {
        if (!counter) return;
        
        const stat = stats[index];
        const obj = { value: 0 };
        
        gsap.to(obj, {
          value: stat.number,
          duration: 6.5,
          ease: "power2.out",
          onUpdate: () => {
            if (stat.isDecimal) {
              counter.textContent = obj.value.toFixed(1) + stat.suffix;
            } else {
              counter.textContent = Math.round(obj.value) + stat.suffix;
            }
          }
        });
      });
    };

    const trigger = ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top 70%",
      onEnter: () => {
        if (!hasAnimatedRef.current) {
          animateCounters();
          hasAnimatedRef.current = true;
        }
      }
    });

    return () => {
      trigger.kill();
    };
  }, []);

  return (
    <section ref={sectionRef} className="stats-section">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-3 col-md-4 col-sm-12">
            <div className="stat-item">
              <h2 
                className="stat-number" 
                ref={(el) => (countersRef.current[0] = el)}
              >
                0+
              </h2>
              <p className="stat-label">Designs Digitized</p>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 d-none d-md-block">
            <div className="stat-divider"></div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-12">
            <div className="stat-item">
              <h2 
                className="stat-number" 
                ref={(el) => (countersRef.current[1] = el)}
              >
                0+
              </h2>
              <p className="stat-label">Happy Clients Worldwide</p>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 d-none d-md-block">
            <div className="stat-divider"></div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-12">
            <div className="stat-item">
              <h2 
                className="stat-number" 
                ref={(el) => (countersRef.current[2] = el)}
              >
                0
              </h2>
              <p className="stat-label">Years Industry Experience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;